import moment from 'moment';

// eslint-disable-next-line
const emailValidationRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// eslint-disable-next-line
const passwordRegex = /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
// eslint-disable-next-line react-hooks/exhaustive-deps
const numberRegex = /^[0-9]+$/;
const TEN_MB_IN_BYTES = 10000000;
const MONTHS = 12;

export const isEmail = (value, errorMessage) => {
  return !emailValidationRegex.test(value) && errorMessage;
};

export const isRequired = (value, errorMessage) => {
  if (value === 0) return false;
  if (!value) return errorMessage;
  return !value.length && errorMessage;
};

export const isNumber = (value, errorMessage) => {
  if (value === 0) return false;
  if (!value) return errorMessage;
  return !numberRegex.test(value.toString()) && errorMessage;
};

export const isRequiredFieldTrueInObject = (value, errorMessage) => {
  return (
    !Object.keys(value).filter(field => value[field]).length && errorMessage
  );
};

export const isRequiredFieldTrueInEachObjectInArray = (
  array,
  fieldName,
  errorMessage
) => {
  let errors = {
    [fieldName]: {}
  };

  for (let i in array) {
    if (array.hasOwnProperty(i)) {
      const item = array[i];
      const obj = item[fieldName];

      if (!Object.keys(obj).filter(field => obj[field]).length) {
        errors[fieldName][i] = errorMessage;
      }
    }
  }

  return !!Object.keys(errors[fieldName]).length && errors;
};

export const isRequiredArray = (array, errorMessage) => {
  return array && !array.length && errorMessage;
};

export const isValidLength = (value, length, errorMessage) => {
  return value.length > length && errorMessage;
};

export const isValidExpirationDate = value => {
  if (!value) return false;

  const dates = value.split('/');
  const month = parseInt(dates[0]);
  const year = parseInt(dates[1]);
  const currentYear = parseInt(moment().format('YY'));

  if (month > MONTHS) return false;
  if (year < currentYear) return false;

  return true;
};

export const isValidPassword = (value, errorMessage) => {
  return !passwordRegex.test(value) && errorMessage;
};

export const isConfirmPassword = (value, valueToConfirm, errorMessage) => {
  return value !== valueToConfirm && errorMessage;
};

export const isValidUploadedImageSize = (value, errorMessage) => {
  if (!value.file) return false;
  return value.file.size > TEN_MB_IN_BYTES && errorMessage;
};

export const isValidUploadedImageFormat = (value, errorMessage) => {
  if (!value.file) return false;
  if (!Object.keys(value.file).length && !value.file.type) return false;
  return (
    value.file.type.indexOf('jpg') < 0 &&
    value.file.type.indexOf('jpeg') < 0 &&
    value.file.type.indexOf('png') < 0 &&
    errorMessage
  );
};

export const isFieldInArray = (field, array, arrayFieldName) => {
  return array.filter(item => item[arrayFieldName] === field).length > 1;
};

export const isRequiredCurrency = field => {
  if (field.USD && field.USD.length && field.USD !== '0' && field.USD !== '0')
    return false;
  if (field.EUR && field.EUR.length && field.EUR !== '0' && field.EUR !== '0')
    return false;
  if (field.NOK && field.NOK.length && field.NOK !== '0' && field.NOK !== '0')
    return false;

  return true;
};


export const isTimeValid = (timeValue) => {
  if (!timeValue) return false;
  if (timeValue._isAMomentObject) return timeValue.isValid();
  if (typeof timeValue === 'string') return timeValue.trim().length > 0;
  return false;
};